import './ArchiveMasthead.scss';

import * as React from 'react';

type Props = {
  backgroundImgPath: string;
  children: React.ReactNode;
};

export default function ArchiveMasthead(props: Props) {
  return (
    <div className="ArchiveMasthead">
      <div className="ArchiveMasthead-content">{props.children}</div>
      <section
        className="ArchiveMasthead-background"
        style={{ backgroundImage: `url(${props.backgroundImgPath})` }}
      >
      </section>
    </div>
  );
}
